<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm6 md6 lg6>
        <v-card >
          <v-toolbar dense flat >
            <v-toolbar-title>Соглашение об использовании</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            Для продолжения работы с системой Вам необходимо ознакомиться с правилами и подтвердить Ваше согласие на работу в соответствии с правилами
              <div>
                <div>
                <a :href="getDepoUrl(getOpenSettings.useRules)">Лицензионное соглашение</a>
                </div>
                <div>
                <a :href="getDepoUrl(getOpenSettings.personInfoRules)">Политика обработки персональных данных</a>
                </div>
                <div>
                <a :href="getDepoUrl(getOpenSettings.personInfoAgreement)">Согласие на обработку персональных данных</a>
                </div>
                <v-checkbox label="Даю согласие" persistent-hint
                  hint="Политику обработки персональных данных изучил, Даю свое согласие на обработку моих персональных данных" v-model="personAgreementCheck"></v-checkbox>
              </div>
          </v-card-text>
          <v-card-actions>
            <v-btn block :disabled="!personAgreementCheck"
              color="primary" @click="apply">Принять</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import server from '../../api/server'

  export default {
    data: () => ({
      personAgreementCheck: false
    }),
    computed: {
      ...mapGetters({
        getOpenSettings: 'getOpenSettings',
        getDepoUrl: 'getDepoUrl'
      })
    },
    methods: {
      apply () {
        if (this.personAgreementCheck) {
          server.apiPost(
          '/api/me/profile/command-rules-agrees', null,
          (data) => {
            this.$store.dispatch('fetchAccountProfile')
            this.$router.push('/home')
          },
          (e) => {
            this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при сохранении соглашения об использовании '})
          }
          )
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Agreement.vue?8cff78d2